import { configureStore } from "@reduxjs/toolkit";
import { purchaseApi } from "../features/purchase/purchaseApi";
import { userDetailsApi } from "../features/userDetails/userDetailsApi";

export const store = configureStore({
  reducer: {
    [purchaseApi.reducerPath]: purchaseApi.reducer,
    [userDetailsApi.reducerPath]: userDetailsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      purchaseApi.middleware,
      userDetailsApi.middleware,
    ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
